if (!customElements.get('currency-switcher')) {
    class CurrencySwitcher extends HTMLElement {
        constructor() {
            super();
            this.selector = {
                main: this.querySelector('.selected-cart-currency'),
                dropDown: this.querySelector('form#currency_form ul'),
                form: this.querySelector('.shopify-currency-form'),
                currency: this.querySelector('#currency')
            }
            this.load();
        }
        load() {
            if(this.selector.main) {
                this.selector.main.addEventListener('click', () => {
                    this.selector.main.classList.toggle('expanded');
                    this.selector.dropDown.classList.toggle('active');
                })
            }
            if(this.selector.form) {
                this.selector.form.addEventListener('submit', event => {
                    event.preventDefault();
                    this.selector.currency.value = event.submitter.dataset.currency;
                    this.selector.main.classList.remove('expanded');
                    this.selector.dropDown.classList.remove('active');
                    event.target.submit();
                })
            }
        }
    }

    customElements.define('currency-switcher', CurrencySwitcher);
}